import { render, staticRenderFns } from "./IndagineEpidemiologicaListeriosiViewComponent.vue?vue&type=template&id=cbea3ebe"
import script from "./IndagineEpidemiologicaListeriosiViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaListeriosiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports